/**
 * Stedi Connection feature auto-registration and exports
 *
 * This module automatically registers the Stedi connection feature when imported,
 * enabling admin users to connect their organization to Stedi for billing.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { stediConnectionFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(stediConnectionFeature);

// Export store (all store-related exports)
export * from './store';

// Export types
export * from './types';
